import React, { useState, Fragment } from 'react';
import Type from 'prop-types';
import { Link, List, ListItem, ListItemText, Divider, Collapse } from '@material-ui/core';
import { ru } from 'locale';
import Document from '../Document';
import useStyles from './Documents.styles';

const Documents = props => {
  const { documents } = props;
  const [lastDocument, ...otherDocuments] = documents;
  const hasMultipleDocuments = documents.length > 1;
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const renderDocument = doc => {
    return (
      <Fragment key={doc.date}>
        <Document document={doc} />
        <Divider />
      </Fragment>
    );
  };

  const renderShowMoreButton = () => {
    return (
      <ListItem button component={Link} onClick={handleExpandClick}>
        <ListItemText
          primary={ru.showAllDocuments}
          primaryTypographyProps={{ color: 'secondary' }}
          classes={{ secondary: classes.documentTitle }}
        />
      </ListItem>
    );
  };

  const renderOtherDocuments = () => {
    return expanded ? (
      <Collapse in={expanded} timeout="auto">
        {otherDocuments.map(doc => renderDocument(doc))}
      </Collapse>
    ) : (
      renderShowMoreButton()
    );
  };

  if (documents.length === 0) {
    return null;
  }

  return (
    <List>
      {renderDocument(lastDocument)}

      {hasMultipleDocuments && renderOtherDocuments()}
    </List>
  );
};

Documents.propTypes = {
  documents: Type.arrayOf(Document.propTypes.document),
};

Documents.defaultProps = {
  documents: [],
};

export default Documents;
